import { DataQueryPresenterModel } from '@osos/shared/types';
// tslint:disable-next-line: no-namespace
export namespace CoreQueryActions {
  export class FetchDataQuery {
    static readonly type = '[Core Query] Fetch Core Query';
    constructor(
      public entity: string,
      public id: string,
      public cached = true,
    ) {}
  }

  export class CreateDataQuery {
    static readonly type = '[Core Query] Save Core Query';
    constructor(public payload: DataQueryPresenterModel) {}
  }

  export class UpdateDataQuery {
    static readonly type = '[Core Query] Update Core Query';
    constructor(public payload: DataQueryPresenterModel) {}
  }

  export class DataQueryRemoveSucess {
    static readonly type = '[Core Query] Data Query Remove Succes';
    constructor(public payload: { queryId: string; entityId: string }) {}
  }

  export class FetchAllTags {
    static readonly type = '[Data Query] Fetch All Tags';
    constructor(public payload: { entityId: string; viewId?: string }) {}
  }

  export class FetchAllTagGroups {
    static readonly type = '[Data Query] Fetch All Tag Groups';
    constructor(public payload: { entityId: string }) {}
  }
}
